export type DigitoVerificador = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 'K';

export function quitarCaracteresNoRut(rut: string): string {
    return rut.replace(/[^0-9kK]/g, '');
}

export function separarRutDv(rut: string): { rutSinDv: string; dv: string } {
    const length = rut.length;
    const rutSinDv = rut.substring(0, length - 1);
    const dv = rut.substring(length - 1);

    return { rutSinDv, dv };
}

export function formatear(texto: string): string {
    const soloNumerosYK = quitarCaracteresNoRut(texto);

    // Separa el texto en una letra K, si existe. Todo lo que quede a la derecha
    // de la K se descarta. No puede haber nada después de una K en un rut.
    const sep = soloNumerosYK.split(/([kK])/);
    const rutNoFormateado = sep.length > 1 ? sep[0] + sep[1].toUpperCase() : sep[0];

    // Comenzar a formatear el rut solo si se han ingresado al menos dos caracteres.
    if (rutNoFormateado.length < 2) {
        return rutNoFormateado;
    }

    const { rutSinDv, dv } = separarRutDv(rutNoFormateado);

    const rutConPuntos = rutSinDv.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return rutConPuntos + '-' + dv;
}

export function esValido(rut: string): boolean {
    const rutSoloNumerosYK = quitarCaracteresNoRut(rut);
    const { rutSinDv, dv } = separarRutDv(rutSoloNumerosYK);

    const rutNumero = parseInt(rutSinDv, 10);

    if (isNaN(rutNumero)) {
        return false;
    }
    return obtenerDigitoVerificador(rutNumero).toString() === dv;
}

export function obtenerDigitoVerificador(rut: number): DigitoVerificador {
    let restoDelRut = rut;
    let factor = 2; // factor es la secuencia 2, 3, 4, 5, 6, 7
    let suma = 0;

    while (restoDelRut > 0) {
        const ultimoDigito = restoDelRut % 10;
        restoDelRut = Math.floor(restoDelRut / 10);

        suma += ultimoDigito * factor;

        // Si el factor supera el valor 7, vuelve a comenzar desde 2
        if (++factor > 7) {
            factor = 2;
        }
    }

    const posibleDv = 11 - (suma % 11);

    if (posibleDv >= 0 && posibleDv <= 9) {
        return posibleDv as DigitoVerificador;
    } else if (posibleDv === 11) {
        return 0;
    } else if (posibleDv === 10) {
        return 'K';
    } else {
        throw new Error('Error interno mientras se calculaba el DV');
    }
}



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/utils/rut.ts